<template>
    <div class="app">
        <transition :name="transitionName">
            <keep-alive>
                <router-view class="appView" v-if="$route.meta.keepAlive">
                </router-view>
            </keep-alive>
        </transition>
        <transition :name="transitionName">
            <router-view class="appView" v-if="!$route.meta.keepAlive" ref="appView"></router-view>
        </transition>

        <van-popup v-model="notifyShow" :overlay="false" position="top">
            <div class="notify-box" :style="{paddingTop: ptHeight + 'rem'}" @click="$router.push({name:'waitSendOrderList'})">
                您有一笔新的待发货订单
            </div>
        </van-popup>
    </div>
</template>

<script>
    // import wx from 'weixin-js-sdk'

    export default {

        name: 'App',
        data() {
            return {
                transitionName: 'slide-left',
                routerStyle:{},
                notifyShow:false,
                notifyShowTimeOut:null,
                statusHeight: 0,
                message:'',
                ptHeight: 0.1
            }
        },
        created() {
            let that = this;
            try {
                window.native.getApp();
                let appStatusHeight = JSON.parse(window.native.getStatusHeight('light')).status;
                let appScreenWidth = JSON.parse(window.native.getStatusHeight('light')).width;
                this.statusHeight = appStatusHeight / appScreenWidth * 750 /100;
                this.ptHeight = this.statusHeight + 0.1
            }
            catch (e) {

            }

        },
        mounted() {
            window.msgCallback = this.msgCallback;

        },
        methods: {
            msgCallback(data){
                let _this = this;
                let childInstance = this.$refs.appView;
                let result = JSON.parse(data);
                console.log('msgCallBackData',result)
                //1002管理端开门    1004寄存柜开门
                switch (result.operationCode){
                    case '1004':
                        childInstance.lockerOpenSuccessCallback(result)
                        break;
                    case '1002':
                        childInstance.supplyOpenSuccessCallback(result)
                        break;
                    case '10000':
                        if(childInstance.getOrderCounts){
                            childInstance.getOrderCounts()
                        }
                        if(result.msgType == 0){
                            if(_this.notifyShowTimeOut){
                                clearTimeout(_this.notifyShowTimeOut);
                            }
                            _this.notifyShow = true;
                            _this.notifyShowTimeOut = setTimeout(function(){
                                _this.notifyShow = false;
                            },5000)
                        }else if(result.msgType == 1){
                            _this.$router.push({name:'waitSendOrderList'})
                        }
                        break;
                }
            }
        },
        watch: {
            '$route'(to, from) {
                if(to.meta.index > from.meta.index){
                    this.transitionName = 'vux-pop-in';
                }else {
                    this.transitionName = 'vux-pop-out';
                }
            }
        }
    }
</script>

<style lang="scss">
    .app{
        width: 100%;
    }
    .appView{
        width: 100%;
        position: absolute;
        -webkit-transition: all .15s cubic-bezier(.55,0,.1,1);
        -moz-transition: all .15s cubic-bezier(.55,0,.1,1);
        -ms-transition: all .15s cubic-bezier(.55,0,.1,1);
        -o-transition: all .15s cubic-bezier(.55,0,.1,1);
        transition: all .15s cubic-bezier(.55,0,.1,1);
    }
    .vux-pop-out-enter-active,
    .vux-pop-out-leave-active,
    .vux-pop-in-enter-active,
    .vux-pop-in-leave-active {
        will-change: transform;
        transition: all 500ms;
        height: 100%;
        position: absolute;
        backface-visibility: hidden;
        perspective: 1000;
    }
    .vux-pop-out-enter {
        opacity: 0;
        transform: translate3d(-100%, 0, 0);
    }
    .vux-pop-out-leave-active {
        opacity: 0;
        transform: translate3d(100%, 0, 0);
    }
    .vux-pop-in-enter {
        opacity: 0;
        transform: translate3d(100%, 0, 0);
    }
    .vux-pop-in-leave-active {
        opacity: 0;
        transform: translate3d(-100%, 0, 0);
    }
    .notify-box{
        background: #1989fa;
        text-align: center;
        font-size: .28rem;
        color: #fff;
        padding: .1rem 1rem;
    }
</style>



// WEBPACK FOOTER //
// App.vue?8ab1f3b6